import { render, staticRenderFns } from "./HandoverMatterDetail.vue?vue&type=template&id=e085d678&scoped=true&"
import script from "./HandoverMatterDetail.vue?vue&type=script&lang=ts&"
export * from "./HandoverMatterDetail.vue?vue&type=script&lang=ts&"
import style0 from "./HandoverMatterDetail.vue?vue&type=style&index=0&id=e085d678&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e085d678",
  null
  
)

export default component.exports